import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../atoms/Typography';
import Picture from '../../atoms/Picture';
import Link from '../../atoms/Link';
import get from 'lodash/get';
import Box from '../Box';
import moment from 'moment';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import useStyles from './style';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import { addHttpsImagePath } from '../../../containers/common/TripAdvisor/preProcess';
import { LANGUAGE_CODE } from '../../../../constants';

const ReviewCard = ({
  title,
  text,
  published_date,
  url,
  readmore,
  rating_image_url,
  user,
  rating,
  reviewByLabel,
  sectionTitle,
  componentName,
  pageName,
  language,
}) => {
  const classes = useStyles();
  const ratingImage = {
    value: {
      src: addHttpsImagePath(rating_image_url),
      alt: rating,
    },
  };
  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.readMoreBtnClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          sectionTitle && sectionTitle.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  return (
    <div className={classes.root}>
      <Typography variant="h5" component="h3" className={classes.reviewHeading}>
        {title}
      </Typography>
      <Typography component="div" className="description">
        <Box component="span" className={classes.description}>
          {text}
        </Box>
        <Box component="span">
          <Link
            onClick={addAnalyticsInfo}
            isCustom={true}
            customHref={url}
            target="_blank"
            isExternalLink={true}
            className={classes.readMore}
            data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick', '')}
            data-link={createDynamicLabels([
              componentName,
              pageName,
              `${readmore && readmore.value}`,
            ])}
          >
            <Typography component="span" variant="body1Bold">
              <Text field={readmore}></Text>
            </Typography>
          </Link>
        </Box>
      </Typography>

      <div
        className={`${classes.ratingImageWrapper} ${language.toLowerCase() === LANGUAGE_CODE.CHINESE.toLowerCase()
          ? 'chinese-styles'
          : ''
          }`}
      >
        <Picture
          className="ratingImage"
          media={{ image: ratingImage, renditionNeeded: false, fallbackBackgroundNeeded: false }}
          alternateAltText={title}
        />
      </div>

      <Typography
        variant="body2"
        className={classes.reviewDate}
        component="div"
        gutterBottom={false}
      >
        <Box component="span">
          <Text
            field={{
              value: `${moment(published_date).format('MMMM DD, YYYY')}`,
            }}
          />
        </Box>
        <Box component="span" className={classes.bylabel}>
          <Text field={reviewByLabel} />
        </Box>
        <Box component="span">
          <Text field={{ value: user.username }} />
        </Box>
      </Typography>
    </div>
  );
};
ReviewCard.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  published_date: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  readmore: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  rating_image_url: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  rating: PropTypes.number.isRequired,
  reviewByLabel: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  sectionTitle: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
};
export default ReviewCard;
